import clsx from 'clsx';
import React, { ReactElement } from 'react';
import {
  makeElementClassNameFactory,
  makeRootClassName,
  StyleProps,
} from '@/utils';
import { Icon, ResponsiveText } from '@/components';
import type { IconData } from '@/components/icon';
import { reportSvg, protectSvg, supportSvg } from './svgs';

export type SummarySectionProps = StyleProps & {
  // add props here
};

const ROOT = makeRootClassName('SummarySection');
const el = makeElementClassNameFactory(ROOT);

type ItemProps = {
  icon: IconData;
  subtitle: string;
  line1: string;
  line2: string;
  line3?: string;
};

function Item(props: ItemProps): ReactElement {
  return (
    <div className={el`item`}>
      <div>
        <Icon
          content={props.icon}
          viewBoxWidth={80}
          viewBoxHeight={100}
          className={el`icon`}
          size="custom"
        />
      </div>
      <div className={el`text-container`}>
        <ResponsiveText
          type="body-lg"
          tabletType='body-md'
          tabletIsHeavy
          isHeavy
          className={el`subtitle`}
        >
          {props.subtitle}
        </ResponsiveText>
        <ResponsiveText type="body-md" tabletType='body-sm'>
          {props.line1}
        </ResponsiveText>
        <ResponsiveText type="body-md" tabletType='body-sm'>
          {props.line2}
        </ResponsiveText>
        <ResponsiveText type="body-md" tabletType='body-sm'>
          {props.line3}
        </ResponsiveText>
      </div>
    </div>
  );
}

const DEFAULT_PROPS = {} as const;

function SummarySection(props: SummarySectionProps): ReactElement {
  const p = { ...DEFAULT_PROPS, ...props };

  return (
    <div className={clsx(ROOT, p.className)}>
      <Item
        subtitle="Get Support"
        line1="Receive free advice"
        line2="on your case."
        icon={reportSvg}
      />
      <Item
        subtitle="Alert"
        line1="Warn the community"
        line2="about malicious"
        line3="crypto activity."
        icon={protectSvg}
      />
      <Item
        subtitle="Support"
        line1="Bring more safety to"
        line2="your community."
        icon={supportSvg}
      />
    </div>
  );
}

export default SummarySection;
